import type { BoxProps } from '@chakra-ui/react'
import { Box } from '@chakra-ui/react'
import { BgColors } from 'commons/design-system/tokens'

export const Section = ({ children, ...rest }: BoxProps) => {
	return (
		<Box outlineOffset='-2px' bg={BgColors.Z5} borderRadius='sm' py={5} px={6} w='full' {...rest}>
			{children}
		</Box>
	)
}
